// @ts-ignore
import * as React from "react";
import { gql, useQuery } from "@apollo/client";

import {
  FindAllCategoriesQueryQuery,
  Category
} from "../../../schemaTypes";

export const findAllCategoriesQuery = gql`
  query FindAllCategoriesQuery {
    findAllCategories {
      id
      name
      imgSrc
      # isArchive
      createdAt
      # updatedAt
    }
  }
`;

export const newCategorySubscription = gql`
  subscription NewCategorySubscription {
    newCategory {
      id
      name
      imgSrc
      isArchive
      createdBy{
        id
        role
      }
      createdAt
      updatedAt
    }
  }
`;

type NewCategorySubscriptionResult = {
  newCategory: Category;
};

export function useFindAllCategories() {
  const { data, loading, subscribeToMore } = useQuery<FindAllCategoriesQueryQuery>(findAllCategoriesQuery);

  // ts-ignore
  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newCategorySubscription,
      updateQuery: (prev, { subscriptionData }: { subscriptionData: { data?: NewCategorySubscriptionResult } }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          findAllCategories: [
            ...prev.findAllCategories,
            subscriptionData.data.newCategory as typeof prev.findAllCategories[0]
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore]);

  return {
    categories: data?.findAllCategories ?? [],
    loading
  };
}